"use client";

import { useEffect } from "react";

/** 앱(리액트)이 실제로 살아났다는 신호 — layout 의 인라인 감시 스크립트가 이 플래그를 본다.
 *  플래그가 안 켜지면 = 브라우저가 앱 JS 를 실행하지 못한 것 → 안내 화면으로 대체한다(무한 스피너 방지). */
export function JsAlive() {
  useEffect(() => {
    (window as unknown as { __ETDU_ALIVE?: number }).__ETDU_ALIVE = 1;
  }, []);
  return null;
}
